import Api from '@/services/Api'

export default {
	register(params) {
		return Api().post('Authentication/AccountSignupSignin', params)
	},
	sendOTP(params) {
		return Api().post('Authentication/ResendAccountVerifyOtp', params)
	},
	verifyOTP(params) {
		return Api().post('Authentication/VerifySigninOtp', params)
	}
}
